var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Utils, CustomElement, Watch, PacemEventTarget } from '@pacem/pacem-core';
var TrackerType;
(function (TrackerType) {
    TrackerType[TrackerType["Cookie"] = 0] = "Cookie";
    TrackerType[TrackerType["LocalStorage"] = 1] = "LocalStorage";
    TrackerType[TrackerType["Pixel"] = 2] = "Pixel";
})(TrackerType || (TrackerType = {}));
const NecessaryCategory = 'necessary';
let PacemJsCookieBannerManagerElement = class PacemJsCookieBannerManagerElement extends PacemEventTarget {
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._updateConsentEntity();
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'manifest':
                this._updateConsentEntity(val);
                break;
            case 'consentEntity':
                this._updateHeaders();
                break;
        }
    }
    consentAll() {
        const contentEntity = Utils.extend({}, this.consentEntity);
        for (let category in this.consentEntity) {
            const cat = category;
            contentEntity[cat] = true;
        }
        this.consentEntity = contentEntity;
    }
    revokeAll() {
        const contentEntity = Utils.extend({}, this.consentEntity);
        for (let category in this.consentEntity) {
            const cat = category;
            contentEntity[cat] = category === NecessaryCategory;
        }
        this.consentEntity = contentEntity;
    }
    toggle(category, value) {
        const entity = this.consentEntity;
        value ??= !entity[category];
        entity[category] = value;
        this.consentEntity = Utils.extend({}, entity);
    }
    _updateConsentEntity(manifest = this.manifest) {
        if (Utils.isNull(manifest)) {
            return;
        }
        const categories = [];
        const entity = {};
        const { managedCookieSets, consentedCookieSets } = manifest;
        for (let category in managedCookieSets) {
            const cat = category;
            categories.push(cat);
            entity[cat] = consentedCookieSets.some(c0 => managedCookieSets[cat].some(c1 => c0.provider === c1.provider && c1.products.some(c2 => c2.name === c0.product)));
        }
        this.categories = categories;
        this.consentEntity = entity;
    }
    _updateHeaders(manifest = this.manifest, entity = this.consentEntity) {
        const consent = [], revoke = [];
        const { managedCookieSets } = manifest;
        for (let category in this.consentEntity) {
            const cat = category;
            const sets = [];
            for (let provider of managedCookieSets[cat]) {
                for (let product of provider.products) {
                    sets.push(product.set.value);
                }
            }
            if (entity[cat]) {
                consent.push(...sets);
            }
            else {
                revoke.push(...sets);
            }
        }
        this.consentHeader = consent.join(',');
        this.revokeHeader = revoke.join(',');
    }
};
__decorate([
    Watch({ emit: true })
], PacemJsCookieBannerManagerElement.prototype, "manifest", void 0);
__decorate([
    Watch({ emit: true })
], PacemJsCookieBannerManagerElement.prototype, "categories", void 0);
__decorate([
    Watch({ emit: true })
], PacemJsCookieBannerManagerElement.prototype, "consentEntity", void 0);
__decorate([
    Watch({ emit: true })
], PacemJsCookieBannerManagerElement.prototype, "consentHeader", void 0);
__decorate([
    Watch({ emit: true })
], PacemJsCookieBannerManagerElement.prototype, "revokeHeader", void 0);
PacemJsCookieBannerManagerElement = __decorate([
    CustomElement({ tagName: 'pacemjs-cookiebanner-manager' })
], PacemJsCookieBannerManagerElement);
export { PacemJsCookieBannerManagerElement };
